import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import useStore from 'store/marketing-activities/apply-list';
import SPButton from 'components/carRental/base/SPButton';
import SPImagesPreview from 'components/base/SPImagesPreview';

import useBaseStore from 'store/base';
import moment from 'moment';

type Iprops = {
  data: any;
}

const ListItem:React.FC<Iprops> = (props) => {
  const { data } = props;

  const { enums, permission } = useBaseStore((state: any) => ({ ...state }));

  const {
    reg_time, action_time, action_desc, action_name, action_tag, action_status,
    enroll_status, activity_cities, activity_veh_group, action_images,
    no_eligible_cities, no_eligible_veh_group
  } = data || {};

  const { openDrawer, activityExit, fetchList, searchData } = useStore(state => ({ ...state }));

  const isDisabled = no_eligible_cities || no_eligible_veh_group;

  const wrapperStyle: React.CSSProperties = {
    marginBottom: 12,
    borderRadius: 6,
    borderLeft: isDisabled ? '3px solid #999' : '3px solid #FF6400',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    backgroundColor: isDisabled ? 'rgba(0, 0, 0 , 0.02)' : '#fff'
  }

  const ellipsisStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }

  const getStatusStyle = (status: number, type: string) => {
    if (type === 'enroll') {
      if (status === 0) {
        return { background: '#1473FF' }; // 蓝色
      }
      if (status === 1) {
        return { background: '#02BC98' }; // 绿色
      }
      return { background: '#999' };
    }
    if (type === 'action') {
      if (status === 1) {
        return { background: '#1473FF' }; // 蓝色
      }
      if (status === 5) {
        return { background: '#02BC98' }; // 绿色
      }
      return { background: '#999' }; // 灰色
    }
    return { background: '#999' };
  }

  const Tag = (props: any) => {
    const { enums, status, type } = props || {};
    
    const tagStyle = {
      marginRight: 8,
      height: 20,
      lineHeight: '20px',
      color: '#fff',
      padding: '0 6px',
      fontSize: '12px',
      borderRadius: '4px',
      display: 'inline-block',
      ...getStatusStyle(status, type),
    }

    const text = enums?.find((item: any) => item.key === status)?.value;

    return (
      <span style={{ ...tagStyle }}>{text}</span>
    )
  }

  const labelStyle = {
    marginRight: '10px',
    fontSize: '14px',
    color: '#666',
  }

  const valueStyle = {
    fontSize: '14px',
    color: isDisabled ? '#666' : '#1F1F1F'
  }

  const errorStyle:React.CSSProperties = {
    backgroundColor: '#FEEBE8',
    color: '#F93822',
    borderRadius: '0px 6px 0px 6px',
    position: 'absolute',
    right: 0,
    top: 0,
    padding: '2px 10px'
  }

  const handleActivityView = () => {
    openDrawer(data, 'view');
  }

  const handleActivityEdit = () => {
    openDrawer(data, 'edit');
  }

  const handleExit = () => {
    Modal.confirm({
      centered: true,
      title: '活动退出确认',
      content: '请确认是否退出当前活动，退出后无法再次参加',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        activityExit({ reg_code : data.reg_code }).then(() => {
          fetchList(searchData);
        });
      },
    });
  }

  const getApplyBtnShow =
    [4, 5].includes(action_status)
      && !enroll_status
      && !no_eligible_cities
      && !no_eligible_veh_group
      && moment((reg_time || [])[0]).isBefore(moment())
      && moment((reg_time || [])[1]).isAfter(moment());

  const activityIsUseful = [4, 5].includes(action_status);

  return (
    <>
      {data.action_code ? <div style={{ width: 'calc(33.33% - 16px)', padding: 20, border: '1px solid rgba(0, 0, 0, 0.12)', ...wrapperStyle }}>
        <div>
          <Tag enums={enums?.f_activity_status_list || []} status={action_status} type="action" />
          <Tag enums={enums?.f_activity_apply_status_list || []} status={enroll_status} type="enroll" />
          { isDisabled && <div style={errorStyle}>不符合条件，不可参与<ExclamationCircleOutlined /></div>}
          <h3 style={{ marginTop: '12px', fontSize: '18px', lineHeight: '26px', fontWeight: 500, color: isDisabled ? '#666' : '#1F1F1F' }}>【{action_tag}】{action_name}</h3>
          <div style={{ marginBottom: 4 }}>
            <span style={labelStyle}>报名时间</span> <span style={valueStyle}>{(reg_time || []).join(' 至 ') }</span>
          </div>
          <div style={{ marginBottom: 4 }}>
            <span style={labelStyle}>活动时间</span> <span style={valueStyle}>{(action_time || []).join(' 至 ') }</span>
          </div>
          <div style={{ display: 'flex', marginBottom: 4 }}>
            <span style={{...labelStyle, flexShrink: 0}}>活动简介</span>
            <div style={{ flex: 1, width: 0 }}>
              <div style={{ ...valueStyle }}>{action_desc?.length > 50 ? action_desc.substring(0, 50) + '...' : action_desc}</div>
            </div>
          </div>
          <div style={{ display: 'flex', marginBottom: 4 }}>
            <span style={{...labelStyle, flexShrink: 0}}>活动限制</span>
            <div style={{ ...valueStyle, width: 0, flex: 1 }}>
              <div>供应商报名需同时满足以下条件</div>
              <div style={ellipsisStyle}>活动城市：{activity_cities}</div>
              <div style={ellipsisStyle}>活动车型：{activity_veh_group}</div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}>
          {/* action_status 1: 待发布,3: 已废弃,4: 活动未开始,5: 活动中,6: 活动结束
          enroll_status 0: 未报名 1:已报名 2:退出活动 */}
          <SPButton permission={permission} permissionKey="activity-view" style={{ padding: '6px 15px', lineHeight: 1 }} onClick={handleActivityView}>查看</SPButton>
          { getApplyBtnShow && <SPButton permission={permission} permissionKey="activity-apply" style={{ marginLeft: '12px', padding: '6px 15px', lineHeight: 1 }} onClick={handleActivityEdit}>报名活动</SPButton>}
          { activityIsUseful&& enroll_status === 1 && <SPButton permission={permission} permissionKey="activity-edit" style={{  marginLeft: '12px', padding: '6px 15px', lineHeight: 1 }} onClick={handleActivityEdit}>编辑</SPButton>}
          { activityIsUseful && enroll_status === 1 && <SPButton permission={permission} permissionKey="activity-exit" style={{ marginLeft: '12px', padding: '6px 15px', lineHeight: 1 }} onClick={handleExit}>退出</SPButton>}
        </div>
      </div> : <div style={{ width: 'calc(33.3% - 8px)' }}></div>}
    </>
  )
}

export default ListItem;